(() => {
  function init(root) {
    if (root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    const grid = root.querySelector('[data-case-grid-list]');
    const items = [...root.querySelectorAll('[data-case-item]')].map((el,index) => {
      let variants = [];
      try { variants = JSON.parse(el.querySelector('[data-case-variants]').textContent); } catch (_) {}
      const title = el.dataset.caseTitle.toLowerCase();
      const details = title + ' ' + el.dataset.caseDescription.toLowerCase();
      return {el,index,title,variants,wallet:/wallet/.test(title),magnetic:/magnetic|magsafe/.test(details),stand:/stand|holder/.test(title),anime:/dragon ball|one piece|pok[eé]mon/.test(title),cartoon:/sonic|kitty|spongebob|minions|elmo|marvel|mcqueen|cartoon/.test(title)};
    });
    const model = root.querySelector('[data-case-model]');
    const type = root.querySelector('[data-case-type]');
    const sort = root.querySelector('[data-case-sort]');
    const stock = root.querySelector('[data-case-available]');
    const heading = root.querySelector('[data-case-heading]');
    const baseHeading = heading.textContent;
    const count = root.querySelector('[data-case-count]');
    const countLabel = count.textContent.trim().replace(/^\d+\s*/, '');
    let category = 'all';
    const modelName = s => s.replace(/\s*#\d+$/, '').trim();
    const models = [...new Set(items.flatMap(item => item.variants.flatMap(v=>v.options.filter(s=>/iphone\s*(16|17|18)/i.test(s)).map(modelName))))];
    const rank = s => { const n = Number(s.match(/\d+/)?.[0] || 0); return n * 10 + (/pro\s*max/i.test(s)?5:/pro/i.test(s)?4:/plus/i.test(s)?3:/air/i.test(s)?2:/\de\b/i.test(s)?1:0); };
    models.sort((a,b)=>rank(a)-rank(b)||a.localeCompare(b)).forEach(value=> { const option=document.createElement('option');option.value=option.textContent=value;model.append(option); });
    function update() {
      let visible = 0;
      items.forEach(item => {
        const currentId = new URL(item.el.querySelector('[data-card-link]').href,location.origin).searchParams.get('variant');
        const previous = item.variants.find(v=>String(v.id)===currentId);
        const modelVariants = item.variants.filter(v=>v.options.some(o=>modelName(o)===model.value)&&(!stock.checked||v.available));
        const selectedVariant = model.value ? (modelVariants.find(v=>previous&&v.options.every((o,i)=>/iphone/i.test(o)||o===previous.options[i]))||modelVariants[0]) : null;
        const fitsModel = !model.value || !!selectedVariant;
        const show = (category==='all'||item[category])&&(!type.value||item[type.value])&&fitsModel&&(!stock.checked||item.el.dataset.caseAvailable==='true');
        item.el.hidden=!show;
        if(show) visible++;
        if(selectedVariant?.image) { const img=item.el.querySelector('[data-card-image]'); if(img){img.removeAttribute('srcset');img.src=selectedVariant.image;} }
        item.el.querySelectorAll('[data-card-link]').forEach(link=>{
          const url=new URL(link.href,location.origin);
          if(selectedVariant)url.searchParams.set('variant',selectedVariant.id);
          else url.searchParams.delete('variant');
          link.href=url.pathname+url.search;
        });
      });
      [...items].sort((a,b)=>sort.value==='az'?a.title.localeCompare(b.title):sort.value==='za'?b.title.localeCompare(a.title):a.index-b.index).forEach(item=>grid.append(item.el));
      heading.textContent=model.value || baseHeading;
      count.textContent=`${visible} ${countLabel}`;
      root.querySelector('[data-case-empty]').hidden=visible>0;
      const breadcrumb=root.querySelector('[data-model-breadcrumb]');breadcrumb.hidden=!model.value;breadcrumb.textContent=model.value?'/ '+model.value:'';
    }
    root.querySelectorAll('[data-case-category]').forEach(button=>button.addEventListener('click',()=>{
      category=button.dataset.caseCategory;
      root.querySelectorAll('[data-case-category]').forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});update();
    }));
    root.addEventListener('click',event=>{if(model.value&&event.target.closest('[data-card-swatch]'))queueMicrotask(update);});
    [model,type,sort,stock].forEach(control=>control.addEventListener('change',update));
    root.querySelector('[data-case-reset]').addEventListener('click',()=>{
      model.value=type.value='';stock.checked=false;category='all';
      root.querySelectorAll('[data-case-category]').forEach(b=>{const active=b.dataset.caseCategory==='all';b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active));});update();
    });
    root.querySelector('[data-case-filter-toggle]').addEventListener('click',event=>{
      const panel=root.querySelector('.case-filter-panel');panel.hidden=!panel.hidden;event.currentTarget.setAttribute('aria-expanded',String(!panel.hidden));
    });
    root.querySelectorAll('[data-case-grid]').forEach(button=>button.addEventListener('click',()=>{
      grid.classList.toggle('case-catalog__grid--large',button.dataset.caseGrid==='2');
      root.querySelectorAll('[data-case-grid]').forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});
    }));
    update();
  }
  const ready=()=>document.querySelectorAll('[data-case-catalog]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
  document.addEventListener('shopify:section:load',ready);
})();
